import getHTTPErrorType from './utils/getHTTPErrorType'
import throwReactQueryError from './utils/throwReactQueryError'

// Handlers
import E401 from './handlers/E401'
import E404 from './handlers/E404'

const responseInterceptor = async ({ error, instance, requestParams }) => {
  /**
   * Specific error handling
   */
  if (getHTTPErrorType(error, 'UNAUTHORIZED')) {
    return E401({ error, instance })
  }

  if (getHTTPErrorType(error, 'NOT_FOUND')) {
    return E404({ error, requestParams })
  }

  /**
   * Default error handling
   */
  return throwReactQueryError(error)
}

export default responseInterceptor
